import { useCallback } from 'react';
import CountryButton from 'components/gruenland/atoms/localization/CountryButton';
import CountryCurrent from 'components/gruenland/atoms/localization/CountryCurrent';
import { Market } from 'components/gruenland/organisms/market-button/MarketButton';
import { getCountryFromKey } from 'project.config';

type Props = { market: Market; onClick: (market: Market) => void; selected?: boolean };

const MarketElement: React.FC<Props> = ({ market, onClick, selected }) => {
  const country = getCountryFromKey(market.countryCode.toLowerCase());
  const handleClick = useCallback(() => onClick(market), [market, onClick]);
  if (!country?.visible) return null;
  if (selected) {
    return <CountryCurrent countryCode={market.countryCode} />;
  }
  return <CountryButton countryCode={market.countryCode} onClick={handleClick} />;
};

export default MarketElement;
